import AppointmentNotes from "./AppointmentNotes";
export default AppointmentNotes;